import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import "./styles.css";

export default function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const { pathname } = useLocation();
  const isLoginPage = pathname === "/ui/login";

  const moonIcon =
    !isDarkMode && isLoginPage
      ? "/ui/images/Truman-UI-moon-grey.svg"
      : "/ui/images/Truman-UI-moon.svg";

  return (
    <button
      type="button"
      className={`border-0 custom-dark-mode-toggle ${isLoginPage ? "login-page-toggle" : ""}`}
      role="switch"
      aria-checked={isDarkMode}
      aria-label="Dark mode"
      onClick={toggleTheme}
    >
      <img
        src={isDarkMode ? "/ui/images/Truman-UI-sun.svg" : moonIcon}
        alt=""
        aria-hidden="true"
      />
    </button>
  );
}
